import React from "react";

import logo2kplay from "../img/logo-2kplay.svg";

import "../style/grade.css";

export function GradeLivre() {
    function toggleDropdown(e: React.MouseEvent<HTMLButtonElement>) {
        const buttonId = e.currentTarget.dataset.id || "";
        const descriptionElement = document.getElementById(buttonId);

        if (descriptionElement) descriptionElement.classList.toggle("hidden");
        e.currentTarget.querySelector(".show-icon")?.classList.toggle("hidden");
        e.currentTarget.querySelector(".hide-icon")?.classList.toggle("hidden");
    }

    return (
        <React.Fragment>
            <div className="grade-container" id="grade-livre">
                <div className="canais-container">
                    <div className="category-item">
                        <button data-id="locais-aberto" onClick={toggleDropdown}>
                            <b>Canais Locais</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="locais-aberto">
                            <div className="column">
                                <span>Band</span>
                                <span>SBT</span>
                                <span>Record TV</span>
                                <span>InterTV Serra Mar</span>
                                <span>Terê FM</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="religiosos-aberto" onClick={toggleDropdown}>
                            <b>Canais Religiosos</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="religiosos-aberto">
                            <div className="column">
                                <span>Rede Vida</span>
                                <span>Canção Nova</span>
                                <span>CNT</span>
                                <span>TV Novo Tempo</span>
                                <span>Rede Século 21</span>
                            </div>
                            <div className="column">
                                <span>RIT TV</span>
                                <span>TV Aparecida</span>
                                <span>TV Rede</span>
                                <span>SBN</span>
                                <span>TV Horizonte</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="compras-aberto" onClick={toggleDropdown}>
                            <b>Canais de Varejo e Compras</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="compras-aberto">
                            <div className="column">
                                <span>Polishop</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="esportes-aberto" onClick={toggleDropdown}>
                            <b>Canais de Esportes</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="esportes-aberto">
                            <div className="column">
                                <span>Woohoo</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="gov-aberto" onClick={toggleDropdown}>
                            <b>Canais Governamentais</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="gov-aberto">
                            <div className="column">
                                <span>Canal Educação</span>
                                <span>TV Brasil</span>
                                <span>Canal GOV</span>
                                <span>TV Câmara</span>
                                <span>TV Justiça</span>
                                <span>TV Senado</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="noticias-aberto" onClick={toggleDropdown}>
                            <b>Canais de Notícias</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="noticias-aberto">
                            <div className="column">
                                <span>Record News</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="cultura-aberto" onClick={toggleDropdown}>
                            <b>Canais de Cultura e Educação</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="cultura-aberto">
                            <div className="column">
                                <span>Cultura</span>
                                <span>TV Ra Tim Bum</span>
                                <span>Univesp TV</span>
                                <span>Futura</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="variedade-aberto" onClick={toggleDropdown}>
                            <b>Canais de Variedades</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="variedade-aberto">
                            <div className="column">
                                <span>Record TV</span>
                                <span>Rede TV</span>
                                <span>Cine Brasil TV</span>
                                <span>ISTV</span>
                                <span>RBTV</span>
                                <span>Rede Brasil</span>
                                <span>BRB TV</span>
                                <span>TV Gazeta</span>
                                <span>PlayTV+</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="filmes-aberto" onClick={toggleDropdown}>
                            <b>Filmes e Séries</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="filmes-aberto">
                            <div className="column">
                                <span>Cine Brasil TV</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="radio-aberto" onClick={toggleDropdown}>
                            <b>Canais de Rádio</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="radio-aberto">
                            <div className="column">
                                <span>Band AM</span>
                                <span>Band News</span>
                                <span>Band Rede 3</span>
                                <span>Band Rede 4</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="agro-aberto" onClick={toggleDropdown}>
                            <b>Canais de Agricultura e Agropecuária</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="agro-aberto">
                            <div className="column">
                                <span>Agro Canal</span>
                                <span>Canal Rural</span>
                                <span>Canal do Criador</span>
                                <span>Terra Viva</span>
                                <span>Canal do Boi</span>
                                <span>Agro+</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export function GradeTotal() {
    function toggleDropdown(e: React.MouseEvent<HTMLButtonElement>) {
        const buttonId = e.currentTarget.dataset.id || "";
        const descriptionElement = document.getElementById(buttonId);

        if (descriptionElement) descriptionElement.classList.toggle("hidden");
        e.currentTarget.querySelector(".show-icon")?.classList.toggle("hidden");
        e.currentTarget.querySelector(".hide-icon")?.classList.toggle("hidden");
    }
    
    return (
        <React.Fragment>
            <div className="grade-container" id="grade-total">
                <div className="canais-container">
                    <div className="category-item">
                        <button data-id="total-locais" onClick={toggleDropdown}>
                            <b>Canais Locais</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="total-locais">
                            <div className="column">
                                <span>Band</span>
                                <span>SBT</span>
                                <span>InterTV Serra Mar</span>
                                <span>Terê FM</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="total-variedades" onClick={toggleDropdown}>
                            <b>Variedades</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="total-variedades">
                            <div className="column">
                                <span>CNT</span>
                                <span>Record TV</span>
                                <span>Rede TV</span>
                                <span>Cine Brasil TV</span>
                                <span>ISTV</span>
                                <span>RBTV</span>
                                <span>Rede Brasil</span>
                                <span>BRB TV</span>
                            </div>
                            <div className="column">
                                <span>PlayTV+</span>
                                <span>TV Gazeta</span>
                                <span>GNT</span>
                                <span>Multishow</span>
                                <span>Viva</span>
                                <span>Modo Viagem</span>
                                <span>Discovery Channel</span>
                                <span>Animal Planet</span>
                            </div>
                            <div className="column">
                                <span>Discovery Turbo</span>
                                <span>Discovery Theater</span>
                                <span>Discovery Science</span>
                                <span>History</span>
                                <span>History 2</span>
                                <span>Arte 1</span>
                                <span>Travel Box</span>
                                <span>Fashion</span>
                            </div>
                            <div className="column">
                                <span>Discovery Home & Health</span>
                                <span>Discovery World</span>
                                <span>HGTV</span>
                                <span>Lifetime</span>
                                <span>Comedy Central</span>
                                <span>MTV</span>
                                <span>BIS</span>
                                <span>MTV Live</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="total-filmes" onClick={toggleDropdown}>
                            <b>Canais de Filmes</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="total-filmes">
                            <div className="column">
                                <span>TLC</span>
                                <span>Megapix</span>
                                <span>TNT</span>
                                <span>Cinemax</span>
                                <span>Space</span> 
                                <span>Studio Universal</span>
                            </div>
                            <div className="column">
                                <span>Universal Channel</span>
                                <span>Warner Channel</span>
                                <span>Investigation Discovery</span>
                                <span>TNT Novelas</span> 
                                <span>TNT Series</span>
                                <span>Prime Box</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="total-agro" onClick={toggleDropdown}>
                            <b>Canais Agro</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="total-agro">
                            <div className="column">
                                <span>Agro Canal</span>
                                <span>Canal Rural</span>
                                <span>Canal do Criador</span>
                                <span>Terra Viva</span>
                                <span>Canal do Boi</span>
                                <span>Agro+</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="total-infantis" onClick={toggleDropdown}>
                            <b>Canais Infantis</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="total-infantis">
                            <div className="column">
                                <span>Discovery Kids</span>
                                <span>Disney Channel</span>
                                <span>Nick</span>
                                <span>Nick Jr</span>
                                <span>Cartoon</span>
                                <span>Gloob</span>
                                <span>Gloobinho</span>
                                <span>TV Ra Tim Bum</span>
                                <span>Kids</span>
                                <span>ZooMoo Kids</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="total-gov" onClick={toggleDropdown}>
                            <b>Canais Governamentais</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="total-gov">
                            <div className="column">
                                <span>Canal GOV</span>
                                <span>Canal Educação</span>
                                <span>TV Brasil</span>
                                <span>TV Justiça</span>
                                <span>TV Senado</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="total-religiosos" onClick={toggleDropdown}>
                            <b>Canais Religiosos</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="total-religiosos">
                            <div className="column">
                                <span>Rede Vida</span>
                                <span>Canção Nova</span>
                                <span>CNT</span>
                                <span>TV Novo Tempo</span>
                                <span>Rede Século 21</span>
                            </div>
                            <div className="column">
                                <span>RIT TV</span>
                                <span>TV Aparecida</span>
                                <span>TV Rede</span>
                                <span>SBN</span>
                                <span>TV Horizonte</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="total-noticias" onClick={toggleDropdown}>
                            <b>Canais de Notícias</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="total-noticias">
                            <div className="column">
                                <span>Record News</span>
                                <span>Band News</span>
                                <span>GloboNews</span>
                                <span>CNN Brasil</span>
                                <span>JP News</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="total-esportes" onClick={toggleDropdown}>
                            <b>Canais de Esportes</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="total-esportes">
                            <div className="column">
                                <span>OFF</span>
                                <span>Sportv</span>
                                <span>Sportv 2</span>
                                <span>Sportv 3</span>
                                <span>Woohoo</span>
                                <span>Band Sports</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="total-compras" onClick={toggleDropdown}>
                            <b>Canais de Varejo e Compras</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="total-compras">
                            <div className="column">
                                <span>Polishop</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="total-cultura" onClick={toggleDropdown}>
                            <b>Canais de Cultura e Educação</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="total-cultura">
                            <div className="column">
                                <span>Cultura</span>
                                <span>Canal Educação</span>
                                <span>TV Brasil</span>
                                <span>TV Ra Tim Bum</span>
                                <span>Univesp TV</span>
                                <span>Futura</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="total-radio" onClick={toggleDropdown}>
                            <b>Canais de Rádio</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="total-radio">
                            <div className="column">
                                <span>Band AM</span>
                                <span>Band News</span>
                                <span>Rádio Bandeirantes</span>
                                <span>Band Rede 4</span>
                            </div>
                        </div>
                    </div>

                    <div className="category-item">
                        <button data-id="total-musica" onClick={toggleDropdown}>
                            <b>Canais de Música</b>

                            <svg width="70" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="show-icon">
                                <path d="M46.4508 79.4004L65.8508 60.0004L46.4508 40.6004C44.5008 38.6504 44.5008 35.5004 46.4508 33.5504C48.4008 31.6004 51.5508 31.6004 53.5008 33.5504L76.4508 56.5004C78.4008 58.4504 78.4008 61.6004 76.4508 63.5504L53.5008 86.5004C51.5508 88.4504 48.4008 88.4504 46.4508 86.5004C44.5508 84.5504 44.5008 81.3504 46.4508 79.4004Z" fill="white"/>
                            </svg>
                            <svg width="30" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg" className="hide-icon hidden">
                                <path d="M8.5625 1.4625L27.9625 20.8625L47.3625 1.4625C49.3125 -0.4875 52.4625 -0.4875 54.4125 1.4625C56.3625 3.4125 56.3625 6.5625 54.4125 8.5125L31.4625 31.4625C29.5125 33.4125 26.3625 33.4125 24.4125 31.4625L1.4625 8.5125C-0.487496 6.5625 -0.487496 3.4125 1.46251 1.4625C3.41251 -0.437502 6.6125 -0.487502 8.5625 1.4625Z" fill="white"/>
                            </svg>
                        </button>

                        <div className="canais-list hidden" id="total-musica">
                            <div className="column">
                                <span>Samba</span>
                                <span>Pagode</span>
                                <span>Samba Raiz</span>
                                <span>Sertanejo</span>
                                <span>Sertanejo & Moda</span>
                                <span>Anos 90</span>
                                <span>Romântica</span>
                                <span>Anos 60</span>
                                <span>Rock</span>
                                <span>Jazz</span>
                            </div>
                            <div className="column">
                                <span>MPB</span>
                                <span>Gospel</span>
                                <span>Pop</span>
                                <span>Pop Hits</span>
                                <span>Blues</span>
                                <span>Black e Hip Hop</span>
                                <span>Funk e Rap</span>
                                <span>Mix</span>
                                <span>Sertanejo</span>
                            </div>
                            <div className="column">
                                <span>Toaleta</span>
                                <span>Eletrônica</span>
                                <span>Pagode</span>
                                <span>Brazil</span>
                                <span>Rock Brasil</span>
                                <span>MPB</span>
                                <span>Rock Clássico</span>
                                <span>Samba</span>
                                <span>Reggae</span>
                            </div>
                            <div className="column">
                                <span>Anos 80</span>
                                <span>POP</span>
                                <span>POP Rock</span>
                                <span>Gospel</span>
                                <span>Globo RJ</span>
                                <span>Globo SP</span>
                                <span>Globo FM</span>
                                <span>CBN SP</span>
                                <span>CBN BSB</span>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </React.Fragment>
    )

}